import { useEffect, useState } from "react";
import { useToast } from "../context/ToastContext";

import { getClients } from "../services/client.service";
import {
  AddTowallet,
  RemoveFromwallet,
} from "../services/admin.transaction.service";
import ClientHeader from "../components/client/ClientHeader";
import ClientTable from "../components/client/ClientTable";
import ClientDetailsModal from "../components/client/ClientDetailsModal";
import ClientWalletModal from "../components/client/ClientAddWalletModal";

export default function Clients() {
  const { showToast } = useToast();
  const [data, setData] = useState({ data: [], last_page: 1, total: 0 });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [balanceFilter, setBalanceFilter] = useState("all");
  
  const [selected, setSelected] = useState(null);
  const [walletTarget, setWalletTarget] = useState(null);
  const [walletMode, setWalletMode] = useState("increase");

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      loadClients();
    }, 400);
    return () => clearTimeout(delayDebounceFn);
  }, [page, search, balanceFilter]);

  async function loadClients() {
    setLoading(true);
    try {
      const params = {
        page,
        search,
        balance: balanceFilter
      };
      const res = await getClients(params);
      setData(res);
    } catch (err) {
      showToast("Erreur de chargement", "error");
    } finally {
      setLoading(false);
    }
  }

  async function handleWalletSubmit(payload) {
    try {
      if (walletMode === "increase") {
        await AddTowallet(payload);
        showToast("Compte rechargé !", "success");
      } else {
        await RemoveFromwallet(payload);
        showToast("Retrait effectué !", "success");
      }
      setWalletTarget(null);
      loadClients();
    } catch (err) {
      showToast(err.response?.data?.message || "Erreur transaction", "error");
    }
  }

  if (loading && data.data.length === 0) {
    return <div className="loaderContainer">Chargement des clients...</div>;
  }

  return (
    <div className="page">
      <ClientHeader
        total={data.total}
        search={search}
        onSearch={(v) => { setSearch(v); setPage(1); }}
        balanceFilter={balanceFilter}
        onBalanceChange={(v) => { setBalanceFilter(v); setPage(1); }}
      />

      <div className={loading ? "tableContainer loading" : "tableContainer"}>
        <ClientTable
          clients={data.data}
          onView={setSelected}
          onWalletAction={(client, mode) => {
            setWalletTarget(client);
            setWalletMode(mode);
          }}
        />
      </div>

      <div className="paginationContainer">
        <div className="pagiInfo">Page <strong>{page}</strong> sur {data.last_page}</div>
        <div className="pagiControls">
          <button className="pagiBtn" disabled={page === 1 || loading} onClick={() => setPage(p => p - 1)}>
            Précédent
          </button>
          <button className="pagiBtn" disabled={page === data.last_page || loading} onClick={() => setPage(p => p + 1)}>
            Suivant
          </button>
        </div>
      </div>

      <ClientWalletModal
        open={!!walletTarget}
        client={walletTarget}
        mode={walletMode}
        onClose={() => setWalletTarget(null)}
        onSubmit={handleWalletSubmit}
      />
      <ClientDetailsModal client={selected} onClose={() => setSelected(null)} />
    </div>
  );
}
